import React, { useState } from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import { Link } from 'react-router-dom';
import { authApi } from '@/api';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next'; // Thêm import

const ForgotPasswordComponent = ({ ...props }) => {
    const { t } = useTranslation(); // Thêm hook
    const [email, setEmail] = useState('');
    const handleResetPass = () => {
        authApi
            .forrgotPassword({ email })
            .then(() => {
                notification.success({ message: t('ForgotPass_NotifySuccess') });
            })
            .catch((err) => {
                const errText = err?.response?.data?.message || '';
                if (errText.includes('not found')) {
                    notification.info({ message: t('ForgotPass_NotifyNotFound') });
                } else {
                    notification.info({ message: t('ForgotPass_NotifyError') });
                }
                console.error(err);
            });
    };
    return (
        <div className="auth option2">
            <div className="auth_left">
                <div className="card">
                    <div className="card-body">
                        <div className="text-center">
                            <Link
                                to="/"
                                className="flex justify-center items-center max-h-[140px] overflow-hidden">
                                <img
                                    className="rounded-lg w-2/3"
                                    src="/assets/images/logo.png"
                                    alt="logo"
                                />
                            </Link>
                            <div
                                className="card-title"
                                style={{ marginTop: '16px' }}>
                                {t('ForgotPass_Title')}
                            </div>
                        </div>
                        <p className="text-muted">{t('ForgotPass_Instruction')}</p>
                        <div className="form-group">
                            <label
                                className="form-label"
                                htmlFor="exampleInputEmail1">
                                {t('ForgotPass_EmailAddress')}
                            </label>
                            <input
                                type="email"
                                className="form-control"
                                id="exampleInputEmail1"
                                aria-describedby="emailHelp"
                                placeholder={t('ForgotPass_EnterEmail')}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className="text-center">
                            <button
                                type="submit"
                                onClick={() => handleResetPass()}
                                className="btn btn-primary btn-block">
                                {t('ForgotPass_SendButton')}
                            </button>
                            <div className="text-muted mt-4">
                                {t('ForgotPass_ForgetIt')}{' '}
                                <Link
                                    to="/login"
                                    className="underline font-bold">
                                    {t('ForgotPass_SendMeBack')}
                                </Link>{' '}
                                {t('ForgotPass_ToSignInScreen')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ForgotPasswordComponent.displayName = 'ForgotPassword';

const ForgotPassword = (props) => {
    return (
        <ErrorWrapper>
            <ForgotPasswordComponent
                data-id="ForgotPassword-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default ForgotPassword;
